import React from "react";
import { useNavigate } from "react-router-dom";
import "./FAQ.css";
import PageHeader from "../components/PageHeader";
import { FaQuestionCircle, FaWhatsapp, FaCode, FaArrowLeft } from "react-icons/fa";

const FAQ = () => {
  const navigate = useNavigate();
  const whatsappNumber = "556791014833";
  const whatsappMessage = encodeURIComponent(
    "Olá! Preciso de ajuda com o Portal Seletivo."
  );

  const faqs = [
    {
      question: "O que é o Portal Seletivo?",
      answer:
        "O Portal Seletivo é uma plataforma digital moderna e segura, projetada para simplificar e otimizar a gestão de processos seletivos. Nosso objetivo é oferecer uma ferramenta intuitiva tanto para os organizadores quanto para os candidatos, garantindo transparência, agilidade e conformidade em todas as etapas.",
    },
    {
      question: "Como posso me registrar no sistema?",
      answer:
        "Para criar sua conta, acesse a página inicial e clique em 'Cadastre-se'. Preencha o formulário com seus dados pessoais, como nome, CPF e e-mail. Após o envio, você receberá um link de verificação no seu e-mail para ativar a conta. Certifique-se de verificar sua caixa de spam caso não o encontre.",
    },
    {
      question: "Esqueci minha senha. Como posso recuperá-la?",
      answer:
        "Na página de login, clique na opção 'Esqueceu a senha?'. Informe o e-mail associado à sua conta e siga as instruções enviadas para criar uma nova senha de acesso. O processo é rápido e seguro.",
    },
    {
      question: "Quais formatos de arquivo são aceitos para o upload de documentos?",
      answer:
        "O sistema aceita documentos nos formatos PDF, PNG e JPG. Recomendamos que o tamanho de cada arquivo não ultrapasse 5MB para garantir um upload rápido e sem falhas. Verifique sempre a descrição dos campos para requisitos específicos.",
    },
    {
      question: "Como acompanho o resultado e o status do edital?",
      answer:
        'Você pode acompanhar o status geral do edital (Aberto, Em Análise, Finalizado) e consultar sua pontuação diretamente na plataforma, na seção "Minhas Inscrições". No entanto, a sua classificação final e a convocação serão divulgadas exclusivamente no <a href="http://diariooficialms.com.br/bandeirantes" target="_blank" rel="noopener noreferrer">Diário Oficial da Prefeitura</a>. É fundamental que você acompanhe as publicações oficiais para não perder nenhuma informação importante.',
    },
  ];

  return (
    <div className="faq-page-container">
      <PageHeader title="Central de Ajuda (FAQ)" icon={<FaQuestionCircle />} />

      <div className="faq-actions">
        <button onClick={() => navigate(-1)} className="btn-ghost back-button">
          <FaArrowLeft size={18} /> Voltar
        </button>
      </div>

      <section className="faq-intro surface-section">
        <span className="faq-intro-badge">Suporte rápido</span>
        <h2>Bem-vindo ao nosso Portal Seletivo</h2>
        <p>
          Reunimos as respostas para as dúvidas mais frequentes para que você
          navegue com tranquilidade. Caso precise de mais ajuda, nossa equipe
          está pronta para te atender.
        </p>
      </section>

      <section className="faq-accordion surface-section">
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <details key={index} className="faq-item">
              <summary className="faq-question">{faq.question}</summary>
              <p
                className="faq-answer"
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              />
            </details>
          ))}
        </div>
      </section>

      <section className="faq-support surface-section">
        <h3>Ainda precisa de ajuda?</h3>
        <p>
          Se sua dúvida não foi respondida, entre em contato conosco diretamente
          pelo WhatsApp.
        </p>
        <a
          href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
          className="whatsapp-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp size={18} /> Chamar no WhatsApp
        </a>
      </section>

      <footer className="faq-footer surface-section">
        <div className="faq-footer-content">
          <FaCode size={18} />
          <p>
            Desenvolvido por{" "}
            <a
              href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Departamento de Tecnologia da Informação
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default FAQ;
